import { Dropdown, type MenuProps } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { useTranslation } from '../../../../../i18n';
import styles from '../style.module.less';
import type { ReactElement } from 'react';
import type { ColumnActionProps } from './types';

export function ColumnAction(props: ColumnActionProps): ReactElement {
  const [t] = useTranslation();
  const items: MenuProps['items'] = [
    { key: 'add-prev', label: t('在前面添加列'), onClick: onAddPrev },
    { key: 'add-next', label: t('在后面添加列'), onClick: onAddNext }
  ];

  if (['setting', 'input'].includes(props.type)) {
    items.push({ key: 'setting', label: t('设置'), onClick: onSetting });
  }

  if (props.length > 1) {
    items.push({ key: 'remove', label: t('删除当前列'), onClick: onRemoveColumn });
  }

  function onAddPrev(): void {
    props.onAction('add-prev-col', { row: -1, col: props.index });
  }

  function onAddNext(): void {
    props.onAction('add-next-col', { row: -1, col: props.index });
  }

  function onRemoveColumn(): void {
    props.onAction('remove-col', { row: -1, col: props.index });
  }

  function onSetting(): void {
    props.onAction('setting-col', { row: -1, col: props.index }, props.option);
  }

  return (
    <Dropdown placement='bottomRight' className={styles.toggle} menu={{ items }}>
      <div className={styles.toggle}>
        <span>{props.option.title}</span>
        <span className={styles.caret}>
          <Icons name='CaretDownOutlined' />
        </span>
      </div>
    </Dropdown>
  );
}
